import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { useAbility } from 'providers/casl'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { fromDTO } from './api/mapper'
import { GET_RICH_PLACEMENT_K_WORDS } from './api/query'

import type { RichPlacementKWordsSlice, UseGetRichPlacementKWords } from './types'
import type { GetRichPlacementKWordsQuery, GetRichPlacementKWordsQueryVariables } from 'gql/graphql'

export const useGetRichPlacementKWords = (): UseGetRichPlacementKWords => {
  const { workspaceId } = useWorkspaceParam()
  const ability = useAbility()

  const { data, isLoading } = useQuery<
    GetRichPlacementKWordsQueryVariables,
    GetRichPlacementKWordsQuery,
    RichPlacementKWordsSlice
  >({
    options: {
      select: ({
        workspaceRichPlacementKwordsConfiguration,
      }: GetRichPlacementKWordsQuery): RichPlacementKWordsSlice =>
        fromDTO(workspaceRichPlacementKwordsConfiguration),
    },
    query: GET_RICH_PLACEMENT_K_WORDS,
    variables: {
      canReadKWordsSiteId: ability.can('read', 'GlobalSetupField-kWordsSiteId'),
      workspaceId,
    },
  })

  return { isLoading, kWords: data }
}
